import {ResourcesInterface, PartnerInterface} from "./interfaces";
import {arrangeVideos} from "./placeVideos"
import {showLocalInfo, showPartnerInfo} from "./debug";
import {displayVolume} from "./sound";
// import {debugOffer} from "./debug"
// import Api from "../../services/Api"
import store from '../../redux/store'

export function getCount() {
  const state = store.getState();
  return state.talkRoom.walks;
}

// const api = Api.getInstance()

const RTCconfiguration = {
  iceCandidatePoolSize: 2,
  iceServers: [
    {urls: 'turn:turn.walkingtalking.com:443', username: 'talking', credential: 'walking'},
    {urls: 'turn:turn.walkingtalking.com:443?transport=tcp', username: 'talking', credential: 'walking'}
  ]
}

export function partnerFromPeer(peerConnection: RTCPeerConnection, resources: ResourcesInterface) {
  for (const partner of resources.partners) {
    if (partner.peerConnection === peerConnection) {
      return partner
    }
  }
  return null
}

function sendSocket(mess: any, webSocket?: WebSocket) {
  if (webSocket) {
    if (webSocket.readyState !== webSocket.OPEN) {
      alert("Web socket is not open, returning")
      return
    }
    webSocket.send(JSON.stringify(mess))
  }

}

function receivePeerCandidate(event: any, resources: ResourcesInterface) {
  const partner = partnerFromPeer(event.target, resources)
  if (partner && event.candidate) {
    const mess = {
      type: 'meeting',
      command: 'icecandidate',
      candidate: event.candidate,
      user_id_to: partner.userId
    }
    sendSocket(mess, resources.webSocket)
    // console.log('HD: send icecandidate')
  } else {
    if (partner) {
      // console.log('--------------- icecandidate is empty, opening remote stream')
      // connectRemoteStream(partner, resources)
    }
  }
}

export function createParticipantContainer(parent: HTMLElement){
  const participantContainer = document.createElement('p')
  parent.appendChild(participantContainer)

  return participantContainer
}

export function createVideoContainer(parent: HTMLElement) {

  const videoContainer = document.createElement('div')

  videoContainer.classList.add('video_element_container')

  parent.appendChild(videoContainer)

  return videoContainer

}

export function createVideoElement(parent: HTMLElement) {

  const videoElement = document.createElement('video')
  videoElement.classList.add('video_element')
  videoElement.height = 200
  videoElement.width = 200
  videoElement.autoplay = true
  videoElement.setAttribute("playsinline", "playsinline")
  videoElement.controls = false
  parent.appendChild(videoElement)

  return videoElement
}

export function createPartnerInfoDiv(resources: ResourcesInterface, parent: HTMLElement, partner: PartnerInterface) {
  const el = document.createElement('div')
  el.classList.add('video_info_div')
  el.classList.add('video_info_div--partner')

  const elImg = document.createElement('img')
  if(partner.userPicture !== '') {
    elImg.src = partner.userPicture
  } else {
    elImg.src = 'assets/images/profile.png'
  }
  elImg.className = "circle button_shadow"
  elImg.id = 'userImage' + partner.userId

  const micWrap = document.createElement('div')

  const nameEl = document.createElement('div')
  const paragraph = document.createElement('p')
  const paragraphStyle ='white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;'
  paragraph.setAttribute('style', paragraphStyle)
  paragraph.innerText = partner.userName
  nameEl.addEventListener('click', function () {
    showPartnerInfo(partner).then(info => {
      resources.stateFunc('info', info)
      resources.stateFunc('showInfo', true)
    })
  })
  nameEl.appendChild(paragraph)
  el.appendChild(micWrap)
  el.appendChild(elImg)
  el.appendChild(nameEl)

  parent.appendChild(el)
}
export function setParticipant(participant: number, parent: HTMLElement | undefined){
  let textStyle = 'color: white;'

  if(parent){
    parent.setAttribute('style', textStyle)
    parent.innerText = participant.toString() 
  }
}

export function createLocalInfoDiv(resources: ResourcesInterface, parent: HTMLElement, displayInfo: Function) {
  const el = document.createElement('div')
  el.classList.add('video_info_div')

  const elImg = document.createElement('img')
  if(resources.userPicture !== '') {
    elImg.src = resources.userPicture
  } else {
    elImg.src = 'assets/images/profile.png'
  }

  elImg.className = "circle button_shadow"
  elImg.id = 'userImage' + resources.userId

  const nameEl = document.createElement('div')
  const paragraph = document.createElement('p')
  const paragraphStyle ='white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;'
  paragraph.setAttribute('style', paragraphStyle)
  paragraph.innerText = 'Du'
  nameEl.classList.add('cursor-pointer')
  nameEl.addEventListener('click', function () {
    // console.log('clicked...')
    showLocalInfo(resources, displayInfo)
  })
  nameEl.appendChild(paragraph)
  el.appendChild(elImg)
  el.appendChild(nameEl)

  parent.appendChild(el)
}

function connectRemoteStream(partner: PartnerInterface, resources: ResourcesInterface) {
  const now = new Date()
  if (partner.connectedRemoteStream > 0) {
    const sinceLastConnect = now.getTime() - partner.connectedRemoteStream
    if (sinceLastConnect < 3000) {
      // console.log('---- connectRemoteStream ran ' + sinceLastConnect + ' ms ago, returning...')
      return
    } else {
      // console.log('---- connectRemoteStream ran ' + sinceLastConnect + ' ms ago,')
    }
  }
  partner.connectedRemoteStream = now.getTime()

  let remoteVideo: HTMLVideoElement = undefined as any

  // console.log('Mapping tracks to elements for ' + partner.offerType)
  if (partner.offerType === 'video') {
    if (!partner.videoElement) {
      partner.videoContainer = createVideoContainer(resources.videoContainerRef.current)
      createPartnerInfoDiv(resources, partner.videoContainer, partner)
      remoteVideo = createVideoElement(partner.videoContainer)
      partner.videoElement = remoteVideo
      if (partner.videoStream) {
        remoteVideo.srcObject = partner.videoStream
        displayVolume(partner.videoStream, partner.videoContainer, partner.volumeInterval)
      } else {
        alert('No partner.videoStream')
      }
    }
  } else {
    // console.log('!!!Bad offer type: ' + partner.offerType)
  }

  if (remoteVideo) {
    // console.log('Öppnar videolänk')
    try {
      remoteVideo.onloadedmetadata = () => {
        // console.log('Remote video created')
        arrangeVideos(resources)
      }
    } catch (error) {
      // console.error('Error opening video camera.', error)
    }
  } else {
    // console.log('No video added, rearranging in case of removed video')
    arrangeVideos(resources)
  }

}

function receivePeerTrack(event: any, resources: ResourcesInterface) {
  // console.log('receivePeerTrack ', event.track)

  if (event.track.kind !== 'audio') {
    return
  }

  const partner = partnerFromPeer(event.target, resources)
  if (!partner) {
    // console.log('Found no partner')
    return
  }

  // console.log('receiving ' + partner.offerType)

  if (!partner.videoStream) {
    partner.videoStream = new MediaStream()
  }
  if (event.track.kind === 'audio') {
    if (!partner.audioTrack) {
      partner.audioTrack = event.track
      partner.videoStream.addTrack(event.track)
    }
  }
}

function peerConnectionStateChange(event: any) {
  // console.log('-------- connectionStateChage: ' + event.target.connectionState)
  if (event.target.connectionState === 'failed') {
    // console.error('Error: RTC connection failed. Talk to support.')
    alert('We lost network connection. Please leave call and enter again to connect again.')
  }
}

function peerConnectionError(event: any) {
  // console.log('-------- connectionError: ', event)
}

function peerIceCandidateError(event: any) {
  // console.log('------ icecandidateerror')
  // console.log(event)
  // alert(event.errorText)
}

function peerGatheringStateChange(event: any, resources: ResourcesInterface, partner: PartnerInterface) {
  // console.log('------ icegatheringstatechange: ' + event.target.iceGatheringState)
  if (event.target.iceGatheringState === 'complete') {
    connectRemoteStream(partner, resources)
  }
  // console.log(event)
}

function peerNegotiationNeeded(event: any) {
  // console.log('------ negotiation needed')
  // console.log(event)
}

export function findPartner(resources: ResourcesInterface, userId: string) {
  for (const partner of resources.partners) {
    if (partner.userId === userId) {
      return partner
    }
  }
  return null
}

// connect is sent by second person connected
export function connectPartner(resources: ResourcesInterface, userId: string, userName: string, userPicture: string) {
  // console.log("**** connect partner", resources)
  const partner = addPartner(userId, userName, userPicture, resources)
  addTracksToPeer(partner, resources)
  sendOffer(resources, partner, 'video')
}

function sendOffer(resources: ResourcesInterface, partner: PartnerInterface, kind: string) {
  partner.peerConnection.createOffer().then((offer: RTCSessionDescriptionInit) => {
    partner.peerConnection.setLocalDescription(offer).then(() => {
      const mess = {
        type: 'meeting',
        command: 'offer',
        user_id_to: partner.userId,
        user_name_from: resources.userName,
        user_picture_from: resources.userPicture,
        kind: kind,
        offer
      }
      sendSocket(mess, resources.webSocket)
      // console.log('send offer to ' + partner.userName)
    }).catch((error: any) => {
      // console.log('Cannot setLocalDesctiption: ' + error)
    })
  }).catch((error: any) => {
    // console.log('Cannot createOffer: ' + error)
  })
}

// handleOffer is sent from second person connected
export function handleOffer(resources: ResourcesInterface, userId: string, userName: string, userPicture: string,
                            offer: any, kind: string) {
  let partner = findPartner(resources, userId)
  if (!partner) {
    partner = addPartner(userId, userName, userPicture, resources)
  }
  partner.offerType = kind

  // console.log('Offer of kind ' + kind)
  // debugOffer(offer)
  addTracksToPeer(partner, resources)
  const remoteDesc = new RTCSessionDescription(offer)

  partner.peerConnection.setRemoteDescription(remoteDesc).then(() => {
    // console.log('HD: setRemoteDescription..')
    partner?.peerConnection.createAnswer().then((answer: RTCSessionDescriptionInit) => {
      // console.log('HD: createAnswer..')
      // debugOffer(answer)
      partner?.peerConnection.setLocalDescription(answer).then(() => {
        // console.log('HD: setLocalDescription')
        const mess = {
          type: 'meeting',
          command: 'answer',
          user_id_to: userId,
          answer
        }
        sendSocket(mess, resources.webSocket)

        if (partner && kind === 'screen') {
          // console.log('--------------- handleOffer done for screen, opening remote stream')
          // Ideally we would call this from icegatheringstate === 'complete', but that is not fired when screen sharing
          connectRemoteStream(partner, resources)
        }
      })
    })
  }).catch((err: any) => {
    // console.log(err)
  })
}

// handleAnswer is handled by first person connected
export function handleAnswer(resources: ResourcesInterface, userId: string, answer: any) {
  const partner = findPartner(resources, userId)
  if (partner) {
    const remoteDesc = new RTCSessionDescription(answer)
    partner.peerConnection.setRemoteDescription(remoteDesc).then(() => {
      // console.log('--- handleAnswer')
    })
    // debugOffer(answer)
  } else {
    alert('Could not find partner ' + userId)
  }
}

export function handleCandidate(resources: ResourcesInterface, userId: string, candidate: any) {
  // console.log('---- Got candidate', candidate)
  const partner = findPartner(resources, userId)
  if (partner) {
    try {
      partner.peerConnection.addIceCandidate(candidate).then(() => {
        // console.log('added icecandidate')
      })
    } catch (e) {
      // console.error('Error adding received ice candidate', e)
    }
  }
}

export function handleToggleMic(resources: ResourcesInterface, userId: string, muted: boolean) {
  const partner = findPartner(resources, userId)
  if (partner) {
    // console.log('------ Found partner')
    partner.muted = muted
    arrangeVideos(resources)
  } else {
    // console.log('------ No partner ' + userId)
  }
}

export function addPartner(userId: string, userName: string, userPicture: string, resources: ResourcesInterface) {
  const peerConnection = new RTCPeerConnection(RTCconfiguration)

  peerConnection.addEventListener('icecandidate', function(event) {
    receivePeerCandidate(event, resources)
  })
  peerConnection.addEventListener('connectionstatechange', peerConnectionStateChange)
  peerConnection.addEventListener('error', peerConnectionError)
  peerConnection.addEventListener('track', function(event) {
    receivePeerTrack(event, resources)
  })
  peerConnection.addEventListener('icecandidateerror', peerIceCandidateError)

  peerConnection.addEventListener('negotiationneeded', peerNegotiationNeeded)

  const partner: PartnerInterface = {
    peerConnection: peerConnection,
    videoStream: new MediaStream(),
    userId: userId,
    userName: userName,
    userPicture: userPicture,
    offerType: 'video',
    connectedRemoteStream: 0,
    volumeInterval: null,
    muted: false
  }
  resources.partners.push(partner)

  peerConnection.addEventListener('icegatheringstatechange', function(event) {
    peerGatheringStateChange(event, resources, partner)
  })

  return partner
}

export function addTracksToPeer(partner: PartnerInterface, resources: ResourcesInterface) {
  const existingTracks: Array<MediaStreamTrack> = []
  partner.peerConnection.getSenders().forEach((sender: RTCRtpSender) => {
    if (sender.track) {
      existingTracks.push(sender.track)
    }
  })
  resources.localStream?.getTracks().forEach((track: MediaStreamTrack) => {
    if (existingTracks.indexOf(track) < 0) {
      if (resources.localStream) {
        partner.peerConnection.addTrack(track, resources.localStream)
        // console.log('Add track to peer: ', track)
        if (track.kind === 'audio' && track.muted) {
          resources.stateFunc('info', 'Your microphone is muted.\nCheck volume level.')
          resources.stateFunc('showInfo', true)
        }
      }
    } else {
      // console.log('Track existed: ', track)
    }
  })

}

export function replaceTrackToPeer(resources: ResourcesInterface) {
  for (const partner of resources.partners) {
    resources.localStream?.getVideoTracks().forEach((track: MediaStreamTrack) => {
      partner.peerConnection.getSenders().forEach((sender: RTCRtpSender) => {
        if (sender.track !== null && sender.track.kind === track.kind) {
          sender.replaceTrack(track).then(() => {
            // console.log('Replacing track ' + track.kind)
          })
          return
        }
      })
    })
  }
}

export function partnerClosed(resources: ResourcesInterface, userId: string) {
  closePartner(userId, resources)
  arrangeVideos(resources)
}

function removeVideoElement(parentElement: HTMLElement, container?: HTMLElement, element?: HTMLVideoElement) {
  if (container) {

    if (element) {
      // console.log('Removing videoElement')
      container.removeChild(element)
      element.remove()
      element.srcObject = null
    }
    // console.log('Removing videoContainer')
    parentElement.removeChild(container)
  }
}

export function closePartner(userId: string, resources: ResourcesInterface) {
  const partner = findPartner(resources, userId)
  if (!partner) {
    // console.log('No partner in partnerClosed for userId ' + userId)
    return
  }

  if (partner.audioTrack) {
    partner.audioTrack.stop()
  }

  if (partner.volumeInterval) {
    clearInterval(partner.volumeInterval)
  }

  partner.peerConnection.getSenders().forEach((sender: RTCRtpSender) => {
    if (sender.track !== null) {
      // console.log('Removing sender track ', sender.track)
      partner.peerConnection.removeTrack(sender)
    }
  })

  if (partner.videoElement) {
    removeVideoElement(resources.videoContainerRef.current, partner.videoContainer, partner.videoElement)
    partner.videoElement = undefined
  }

  partner.peerConnection.close()

  resources.partners = resources.partners.filter(obj => obj !== partner);
}

function stopStream(stream: MediaStream) {
  stream.getTracks().forEach((track: MediaStreamTrack) => {
    if (track.readyState === 'live') {
      // console.log('Stopping track ' + track.kind)
      track.stop()
    } else {
      // console.log(track.kind + ': ' + track.readyState)
    }
  })
}

export function unmountVideo(resources: ResourcesInterface) {
  if (resources.localStream) {
    stopStream(resources.localStream)
    // console.log('Closing local stream')
  }

  for (const partner of resources.partners) {
    if (partner.videoStream) {
      stopStream(partner.videoStream)
    }

    if (partner.peerConnection) {

      partner.peerConnection.removeEventListener('icecandidate', function(event) {
        receivePeerCandidate(event, resources)
      })
      partner.peerConnection.removeEventListener('connectionstatechange', peerConnectionStateChange)
      partner.peerConnection.removeEventListener('error', peerConnectionError)
      partner.peerConnection.removeEventListener('track', function(event) {
        receivePeerTrack(event, resources)
      })
      partner.peerConnection.removeEventListener('icecandidateerror', peerIceCandidateError)
      partner.peerConnection.removeEventListener('icegatheringstatechange', function(event) {
        peerGatheringStateChange(event, resources, partner)
      })
      partner.peerConnection.removeEventListener('negotiationneeded', peerNegotiationNeeded)

      partner.peerConnection.close()
      // console.log('Removed peer event listeners')
    }
  }
}
